import React, { useEffect, useState } from 'react'
import { Menu, Dropdown, Space, Col, Checkbox, Select, Row } from 'antd'
import filterSvg from '../../../assets/Images/filter.svg'
import { SearchOutlined } from '@ant-design/icons'

import type { MenuProps } from 'antd'
import { debounce } from 'lodash'

const ActionHeaders = ({ hidCols, setCols, search, sort }: any) => {
  const [visible, setVisible] = useState(false)
  const [searchQuery, setSearchQuery] = useState('')

  const handleVisibleChange = (flag: boolean) => {
    setVisible(flag)
  }
  const handleSearchChange = (e: any) => {
    setSearchQuery(e)
    search(searchQuery)
  }
  const debounced = debounce(handleSearchChange, 300)

  const onChangeColumnCheckBox = (e: any) => {
    const updatedHiddenColumns = {
      ...hidCols,
      [e.target.name]: e.target.checked,
    }

    setCols(updatedHiddenColumns)
    localStorage.setItem('MentorCols', JSON.stringify(updatedHiddenColumns))
  }
  useEffect(() => {
    const storedHiddenColumns = localStorage.getItem('MentorCols')
    if (storedHiddenColumns) {
      setCols(JSON.parse(storedHiddenColumns))
    }
  }, [])
  const handleChangeSortName = (value: string) => {
    sort(value)
  }
  const menu2 = (
    <Menu
      title="show all"
      items={[
        {
          label: (
            <Row gutter={10} justify="space-between">
              <Col span={4}>
                <Checkbox
                  defaultChecked={hidCols.firstName}
                  name="firstname"
                  onChange={onChangeColumnCheckBox}
                ></Checkbox>
              </Col>
              <Col span={20}>Name</Col>
            </Row>
          ),
          key: '1',
        },
        {
          label: (
            <Row gutter={10} justify="space-between">
              <Col span={4}>
                <Checkbox
                  defaultChecked={hidCols.email}
                  name="email"
                  onChange={onChangeColumnCheckBox}
                ></Checkbox>
              </Col>
              <Col span={20}>Email</Col>
            </Row>
          ),
          key: '2',
        },
        {
          label: (
            <Row gutter={10} justify="space-between">
              <Col span={4}>
                <Checkbox
                  defaultChecked={hidCols.phone}
                  name="phone"
                  onChange={onChangeColumnCheckBox}
                ></Checkbox>
              </Col>
              <Col span={20}>Phone number</Col>
            </Row>
          ),
          key: '3',
        },
        {
          label: (
            <Row gutter={10} justify="space-between">
              <Col span={4}>
                <Checkbox
                  defaultChecked={hidCols.dob}
                  name="dob"
                  onChange={onChangeColumnCheckBox}
                ></Checkbox>
              </Col>
              <Col span={20}>Date of Birth</Col>
            </Row>
          ),
          key: '4',
        },
        {
          label: (
            <Row gutter={10} justify="space-between">
              <Col span={4}>
                <Checkbox
                  defaultChecked={hidCols.totalhours}
                  name="totalhours"
                  onChange={onChangeColumnCheckBox}
                ></Checkbox>
              </Col>
              <Col span={20}>Total hours</Col>
            </Row>
          ),
          key: '5',
        },
        {
          label: (
            <Row gutter={10} justify="space-between">
              <Col span={4}>
                <Checkbox
                  defaultChecked={hidCols.traininglevel}
                  name="traininglevel"
                  onChange={onChangeColumnCheckBox}
                ></Checkbox>
              </Col>
              <Col span={20}>Training level</Col>
            </Row>
          ),
          key: '6',
        },
        {
          label: (
            <Row gutter={10} justify="space-between">
              <Col span={4}>
                <Checkbox
                  defaultChecked={hidCols.status}
                  name="status"
                  onChange={onChangeColumnCheckBox}
                ></Checkbox>
              </Col>
              <Col span={20}>status</Col>
            </Row>
          ),
          key: '7',
        },
        {
          label: (
            <Row gutter={10} justify="space-between">
              <Col span={4}>
                <Checkbox
                  defaultChecked={hidCols.action}
                  name="action"
                  onChange={onChangeColumnCheckBox}
                ></Checkbox>
              </Col>
              <Col span={20}>Action</Col>
            </Row>
          ),
          key: '8',
        },
      ]}
    />
  )

  return (
    <Space size={20} align="center" className="mentors-table-header">
      <Dropdown
        overlay={menu2}
        onVisibleChange={handleVisibleChange}
        visible={visible}
      >
        <a onClick={e => e.preventDefault()}>
          <Space>
            <img src={filterSvg} alt=""></img>
          </Space>
        </a>
      </Dropdown>
      <Select
        className="custom-select-field"
        defaultValue="name"
        placeholder="Sort by: Name"
        allowClear
        onChange={handleChangeSortName}
      >
        <Select.Option value="name">Sort by: Name</Select.Option>
        <Select.Option value="email">Sort by: Email</Select.Option>
        <Select.Option value="-createdAt">Sort by: CreatedAt</Select.Option>
      </Select>
      <div>
        <div className="search-input-box">
          <input
            type="search"
            className="search-input-group"
            placeholder="Search"
            onChange={e => {
              e.preventDefault()
              debounced(e.target.value)
            }}
          />
          <SearchOutlined />
        </div>
      </div>
    </Space>
  )
}
export default ActionHeaders
